import React from 'react'

export default () => (
  <div className="social-media">
    <a href="https://www.linkedin.com/in/mauro-carrero-14736421/">LinkedIn</a>
    <a href="https://github.com/maurocarrero">Github</a>
    <a href="https://twitter.com/mauro_carrero">Twitter</a>
  </div>
)



/** WEBPACK FOOTER **
 ** ./src/components/SocialMedia.js
 **/